import {
  CLASSES,
  PRICE_VIEW,
  setB2BView,
  setB2CView,
  B2B_B2C_TOGGLE_EVENT,
  closeProtectedModal,
  openProtectedModal
} from './b2c-b2b-toggler-helper-2.js'
;(async () => {
  const currentClass = localStorage.getItem(PRICE_VIEW) || CLASSES.B2B

  document.body.classList.add(currentClass)

  const b2bTextEl = document.querySelector('.announcement__text.b2b-price')
  const b2cTextEl = document.querySelector('.announcement__text.b2c-price')
  const modalEl = document.querySelector('#modalWindow')
  const loginBtn = document.querySelector('#modalWindow .btn--login')
  const cancelBtns = document.querySelectorAll('#modalWindow .btn--cancel')
  const inputEl = document.querySelector('#modalWindow #reLogin')

  if (!b2bTextEl || !b2cTextEl || !loginBtn) {
    console.error(
      `announcement__text.b2b-price or announcement__text.b2c-price is not found`
    )
    return
  }

  const closeModal = () => {
    closeProtectedModal()
    inputEl.value = ''
  }

  loginBtn.addEventListener('click', () => {
    const pass = inputEl.value

    setB2BView(pass)
    inputEl.value = ''
  })

  cancelBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      closeModal()
    })
  })

  modalEl.addEventListener('click', e => {
    if (e.target === modalEl) {
      closeModal()
    }
  })

  b2bTextEl.addEventListener('click', setB2CView)
  b2cTextEl.addEventListener('click', openProtectedModal)

  // NOTE: if we need to change pseudochecout to general checkout
  // const initCheckoutLinks = () => {
  //   const checkoutLinks = document.querySelectorAll('a[name="checkout"]')
  //   const rootUrl = window?.theme?.routes?.root || '/'

  //   checkoutLinks.forEach(link => {
  //     if (document.body.classList.contains(CLASSES.B2B)) {
  //       link.href = rootUrl + 'checkout'
  //     } else if (document.body.classList.contains(CLASSES.B2C)) {
  //       link.href = rootUrl + 'pages/checkout'
  //     }
  //   })
  // }

  // initCheckoutLinks()

  // window.addEventListener(B2B_B2C_TOGGLE_EVENT, initCheckoutLinks)
  // document.addEventListener('theme:cart:loaded', initCheckoutLinks)
})()
